export default {
  VARIANT: 'variante',
  VARIANT2: 'variante2',
  DEFAULT: 'default',
  NEW_FLOW: 'NewListConfigureFlow',
  ASYNC_VARIANT: 'AsyncVariant',
  FORCE_INTERACTION: 'forceInteraction',
  CONTROL: 'Control',
  UPGRADE: 'Upgrade',
  FORCED_SELECTED: 'forcedSelected',
  RENTPROTECTION_CONTROL: 'Control',
  RENTPROTECTION_VARIANT: 'RentProtectionPWA',
  RENTPROTECTION_VARIANT_LOCAL: 'RentProtectionLOCAl',
  STEP_RENTALCOVER: 'StepRentalCover',
  STEP_RENTALCOVER_REMOVE_PLANS: 'RcConfigureRemovePlans',
  LIST_FILTERS: 'ListFilters',
  ONLY_RENTAL_PROTECTION: 'OnlyRentalProtection',
  ONLY_RENTAL_COVER: 'OnlyRentalCover',
  WITHOUT_PROTECTIONS: 'WithoutProtections',
  SHOW_INFO_PROFILE_ANALYSIS: 'ShowInfoProfileAnalysis',
  SHOW_INFO_PROFILE_ANALYSIS_V2: 'ShowInfoProfileAnalysisV2',
  SHOW_ALERT_PID: 'ShowAlertPID',
  MULTISTORE: 'Multistore'
}
